import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ToastStatus } from '../../constants/toastMessage.constants';

import topicKeys from 'hooks/topic-management/_queryKeys';

// models
import { FormulaBulkUpdate } from '../../models/formula.model';

// service
import API from '../../services/api';
import { toastService } from '../../services/toast.service';

import alternateKeys from '../alternates/_queryKeys';
// helper
import formulaKeys from './_queryKeys';

const useFormulaBulkUpdateMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (updates: FormulaBulkUpdate[]) =>
            API.updateBulkFormula(updates),

        onSuccess: () => {
            toastService.showNotificationToast(
                ToastStatus.Success,
                `Formulas updated successfully.`,
            );
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
            queryClient.invalidateQueries({ queryKey: topicKeys.all() });
            queryClient.invalidateQueries({
                queryKey: ['personalization-map'],
            });
            queryClient.invalidateQueries({
                queryKey: [...alternateKeys.getAllVariants()],
            });
        },
        onError: (error) => {
            toastService.showNotificationToast(
                ToastStatus.Error,
                `${error.message}`,
            );
        },
    });
};

export default useFormulaBulkUpdateMutation;
